// Settings Store
import { getField } from 'vuex-map-fields'

const state = {
  settings: {},
  pendingSettings: false,
}

const getters = {
  getField,
}

const actions = {
  getSettings({ commit }) {
    return new Promise(resolve => {
      commit('SET_PENDING')
      this.api.items.getItem('settings').then(({ data }) => {
        commit('SET_SETTINGS', data)
        commit('SET_PENDING')
        resolve()
      })
    })
  },
}

const mutations = {
  SET_SETTINGS: (state, payload) => {
    state.settings = payload
  },
  SET_PENDING: state => {
    state.pendingSettings = !state.pendingSettings
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
